import { createBrowserRouter, RouteObject, useLocation } from 'react-router-dom'
import routes from 'config/routes'
import FacilitiesScreen from 'screens/FacilitiesScreen'
import OnboardingExteriorWallsScreen from 'screens/OnboardingExteriorWallsScreen'
import OnboardingRoofsScreen from 'screens/OnboardingRoofsScreen'
import OnboardingInteriorWallsScreen from 'screens/OnboardingInteriorWallsScreen'
import OnboardingCeilingsScreen from 'screens/OnboardingCeilingsScreen'
import OnboardingObstructionsScreen from 'screens/OnboardingObstructionsScreen'
import OnboardingComfortZonesScreen from 'screens/OnboardingComfortZonesScreen'
import NotFoundRoute from 'components/NotFoundRoute'
import { Navigate } from 'react-router-dom'
import { ShortUrlRedirect } from '~/screens/FacilityScreen/components/ShortUrlRedirect'
import { LegacyUrlRedirect } from '~/screens/FacilityScreen/components/LegacyUrlRedirect'
import { wrapCreateBrowserRouter } from '@sentry/react'
import { Providers } from '~/providers'
import DuplicateFacilityModal from '~/components/Modals/DuplicateFacilityModal'
import EditFacilityModal from '~/components/Modals/EditFacilityModal'
import UserSearchModal from '~/components/Modals/TestFolder'
import { AppBar } from '~/components/AppBar'
import Dashboard from '~/components/Dashboard'

const facilitiesScreenModals: RouteObject[] = [
  { path: 'duplicate-facility/:id', element: <DuplicateFacilityModal /> },
  { path: 'edit-facility/:id', element: <EditFacilityModal /> },
  { path: ':id/user-search', element: <UserSearchModal /> },
]

function Index() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const isAuth0Redirect = params.has('code') && params.has('state')

  return <Dashboard noAction>{!isAuth0Redirect && <Navigate replace to={routes.facilities} />}</Dashboard>
}

export const router = wrapCreateBrowserRouter(createBrowserRouter)([
  {
    element: <Providers />,
    children: [
      {
        index: true,
        element: <Index />,
      },
      { path: `${routes.onboarding[1].full}/*`, element: <OnboardingExteriorWallsScreen /> },
      { path: `${routes.onboarding[2].full}/*`, element: <OnboardingRoofsScreen /> },
      { path: `${routes.onboarding[3].full}/*`, element: <OnboardingInteriorWallsScreen /> },
      { path: `${routes.onboarding[4].full}/*`, element: <OnboardingCeilingsScreen /> },
      { path: `${routes.onboarding[5].full}/*`, element: <OnboardingObstructionsScreen /> },
      { path: `${routes.onboarding[6].full}/*`, element: <OnboardingComfortZonesScreen /> },
      {
        path: '/facility',
        element: <AppBar />,
        children: [
          { path: ':id', element: <ShortUrlRedirect /> },
          { path: ':id/floor/:floorId/version/:versionId', element: <LegacyUrlRedirect /> },
          { path: ':id/area/:floorId/version/:versionId/*', lazy: () => import('~/screens/FacilityScreen') },
        ],
      },
      {
        path: `${routes.facilities}/*`,
        element: <FacilitiesScreen view="My Facilities" />,
        children: facilitiesScreenModals,
      },
      {
        path: `${routes.facilityFavorites}/*`,
        element: <FacilitiesScreen view="My Favorites" />,
        children: facilitiesScreenModals,
      },
      {
        path: `${routes.facilityArchived}/*`,
        element: <FacilitiesScreen view="Archived" />,
        children: facilitiesScreenModals,
      },
      { path: `${routes.faq}/*`, lazy: () => import('~/screens/FAQScreen') },
      { path: `${routes.templates}/*`, lazy: () => import('~/screens/TemplatesScreen') },
      { path: `${routes.reports}/*`, lazy: () => import('~/screens/ReportsScreen') },
      { path: `${routes.settings}/*`, lazy: () => import('~/screens/SettingsScreen') },
      { path: `${routes.reassign}/*`, lazy: () => import('~/screens/ReassignFacilitiesScreen') },
      { path: `${routes.salesforceAuthentication}/*`, lazy: import('~/screens/SalesforceAuthenticationScreen') },
      { path: `${routes.salesforceCallback}/*`, lazy: () => import('~/screens/SalesforceCallbackScreen') },
      { path: '*', element: <NotFoundRoute /> },
    ],
  },
])
